import { render, staticRenderFns } from "./ChangeUserPassword.vue?vue&type=template&id=1bec1fe8&scoped=true&"
import script from "./ChangeUserPassword.vue?vue&type=script&lang=js&"
export * from "./ChangeUserPassword.vue?vue&type=script&lang=js&"
import style0 from "./ChangeUserPassword.vue?vue&type=style&index=0&id=1bec1fe8&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bec1fe8",
  null
  
)

export default component.exports